import React from 'react';
import {
    Typography,
    Grid,
    TextField,
    InputAdornment,
    Box
} from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import Organization from './Organization';
import Projects from './Projects';
import TimerTracking from './TimerTracking';
import SecurityLogin from './SecurityLogin';
import Members from './Members';
import TabTitle from '../../../pages/Member-Profile-Edit/TabTitle';
import RadioBoxGroup from '../../../components/RadioButtons/RadioBoxGroup';
import Permissions from './Permissions';

const labelStyle = {
    fontWeight: 500,
    mb: 0.5,
    color: '#1A1F36',
};

const inputStyle = {
    height: 46,
    fontSize: '14px',
};

const SettingsTabsContent = ({ activeTab, menuItems }) => {
    switch (activeTab) {
        case 0:
            return (
                <>
                    <TabTitle title="ORGANIZATION" />
                    <Organization />
                </>
            );

        case 1:
            return (
                <>
                    <TabTitle title="PROJECTS" />
                    <Projects />
                </>
            );

        case 2:
            return (
                <>
                    <TabTitle title="TIMER & TRACKING" />
                    <TimerTracking />
                </>
            );

        case 3:
            return (
                <>
                    <TabTitle title="SECURITY & LOGIN" />
                    <SecurityLogin />
                </>
            );

        case 4:
            return (
                <>
                    <TabTitle title="MEMBERS" />
                    <Members />
                </>
            );

        case 5:
            return (
                <>
                    <TabTitle title="PERMISSIONS" />
                    <Permissions />
                </>
            );
        default:
            return (
                <Typography variant="body1" color="text.secondary">
                    <TabTitle title={menuItems[activeTab] || 'Details'} />
                </Typography>
            );
    }
};

export default SettingsTabsContent;
